import { ToolbarType, TextDisplay, } from '@i18nspect/types';
import { getToolbarType } from '../../../state';
import state from '../state';
import { notifySubscribers } from '../../../state';
import bridge from '../../../bridge';
import { isEnumInclude } from '../../../utils';
export var setupListeners = function () {
    try {
        if (getToolbarType() === ToolbarType.Language) {
            console.log('[I18nspect] Interceptor: Adding language listeners');
            var onSetTranslations = function (payload) {
                if (payload == null)
                    return;
                var language = payload.language, translations = payload.translations;
                if (language == null || translations == null)
                    return;
                var i18n = state.getInterceptorI18n();
                Object.keys(translations).forEach(function (ns) {
                    i18n.addResourceBundle(language, ns, translations[ns], true, true);
                });
                i18n.changeLanguage(language, notifySubscribers);
            };
            var onSwitchDisplay = function (newDisplay) {
                if (!isEnumInclude(TextDisplay, newDisplay))
                    return;
                if (state.display !== newDisplay) {
                    state.display = newDisplay;
                    notifySubscribers();
                }
            };
            bridge.language.onSetTranslations(onSetTranslations);
            bridge.language.onSwitchDisplay(onSwitchDisplay);
            /* TODO
          
            {
              const onToggleEnableInspect = (enable: boolean) => {
                state.enableInspect = enable;
                notifySubscribers();
              };
              window.__I18NSPECT_DEBUG__.mobile =
                window.__I18NSPECT_DEBUG__.mobile || {};
      
              window.__I18NSPECT_DEBUG__.mobile.app =
                window.__I18NSPECT_DEBUG__.mobile.app || {};
      
              window.__I18NSPECT_DEBUG__.mobile.app = {
                ...window.__I18NSPECT_DEBUG__.mobile.app,
                // TODO: FIXME
                // setTranslations: onSetTranslations,
                switchMode: onSwitchDisplay,
                toggleEnableInspect: onToggleEnableInspect,
              };
      
              window.__I18NSPECT_DEBUG__.mobile?.inspector?.onReady?.();
            }
            */
        }
    }
    catch (error) {
        console.log('[I18nspect] Interceptor: Fail adding language listeners');
        console.error(error);
    }
};
